import React from "react";
import classNames from "classnames";

export const StepperNav = ({ sections = [], activeIndex = 0, onStep }) => {
  return (
    <nav className="flex items-start justify-center w-full px-4 lg:px-6 py-8">
      {sections.map((s, idx) => {
        const isActive = idx === activeIndex;
        const isDone = idx < activeIndex;
        return (
          <React.Fragment key={s.title}>
            <button
              type="button"
              onClick={() => onStep?.(idx)}
              className="flex flex-col items-center gap-2 flex-1 text-center group cursor-pointer"

            >
              <div
                className={classNames(
                  "text-sm font-semibold",
                  {
                    "text-teal-500": isActive || isDone,
                    "text-gray-400": !isActive && !isDone,
                  }
                )}
              >
                {idx + 1}.
              </div>
              <div
                className={classNames("text-sm font-medium", {
                  "text-gray-800": isActive || isDone,
                  "text-gray-500": !isActive && !isDone,
                })}
              >
                {s.title}
              </div>
            </button>
            {idx < sections.length - 1 && (
              <div
                className={classNames("h-0.5 mt-2.5 flex-1", {
                  "bg-teal-500": isDone,
                  "bg-gray-200": !isDone,
                })}
              />
            )}
          </React.Fragment>
        );
      })}
    </nav>
  );
};
